import React from "react";
import ErrorBoundary from './components/ErrorBoundary';

// Ruído benigno do Radix/observers: não deve abrir o overlay de erro do dev server.
const RO_NOISE = 'ResizeObserver loop';
window.addEventListener('error', (e) => {
  if (typeof e.message === 'string' && e.message.includes(RO_NOISE)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/dna-tokens.css";
import { installLegacyHostInterceptor } from "@/lib/legacyHostInterceptor";
import App from "@/App";

// PATCH: instala interceptor ANTES de qualquer chamada do app.
// Qualquer request para domínios legacy (ex.: dnahub-school-1.emergent.host)
// é reescrita para mesma origem — elimina CORS/OAuth quebrado em produção.
installLegacyHostInterceptor();


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
